
import React from 'react'
import Select from 'react-select'

// Icons
import KeyboardArrowDownIcon from 'assets/icons/general/KeyboardArrowIcon'

function MultipleSelectInput({
    name,
    classNameDiv,
    classNameInput = "text-sm md:text-base lg:text-lg",
    label,
    required,
    options,
    disabled,
    onChange,
    setFieldValue,
    onBlur,
    error,
    value,
    placeholder
}) {
    return (
        <div className={`flex flex-col space-y-2 ${classNameDiv}`}>
            {label && (
                <label htmlFor={name} className='font-semibold flex text-sm md:text-base lg:text-lg'>
                    <p>{label}</p>
                    {required && (
                        <span className='text-red-500'>*</span>
                    )}
                </label>
            )}
            <div className='relative flex items-center overflow'>
                <Select
                    isMulti
                    id={name}
                    name={name}
                    className={`react-select-container ${classNameInput} w-full bg-transparent focus:outline-none focus:border-2 focus:border-blue-500`}
                    classNamePrefix="react-select"
                    placeholder={placeholder}
                    options={options}
                    value={value}
                    onChange={(value) => setFieldValue(name, value)}
                    onBlur={onBlur}
                    isDisabled={disabled}
                />
            </div>
            {error && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{error}</p>
            )}
        </div>
    )
}

export default MultipleSelectInput